<template>

	<div class="poll-users">
		<div class="date-wrapper">
			<FilterChipButton
				:isButtonActive="isButtonActive"
				:chipsList="chipsList"
				:clearFilter="clearFilter"
				@handleChipClick="handleChipClick"
			/>

			<div v-if="filterModalIsVisible">
				<FilterModal
            :chipsFromFilterPoll="chipsFromFilterPoll"
					:filterModalIsVisible="filterModalIsVisible"
					:currentModalFilter="currentModalFilter"
					:currentModalLabel="currentModalLabel"
					:selectedChips="selectedChips"
					:filters="filters"
					:dateError="date.error"
					:dateOption="date.option"
					:dateRange="date.selectedRange"
					@closeModal="closeModal"
					@applySelection="applySelection"
					@setItem="setItem"
				/>
			</div>
		</div>
		<v-skeleton-loader
			v-if="postPollUsersLoading"
			width="555"
			class="mt-5"
			type="list-item-avatar, list-item-three-line, card-heading, actions"
		></v-skeleton-loader>
    <div v-else-if="postPollUsers.length === 0">
      <NewsFeedEmpty
          title="Poll results are empty at the moment."
          description="Check back later."
      />
    </div>
			<div v-else class="mt-5" v-for="user in postPollUsers" :key="user.user_id">
				<div class="poll-users__container">
					<div class="poll-users__user-avatar">
						<Avatar borderRadius="square" class="mr-4 post-preview-card__avatar" :size="52" :avatar="user.user_logo" />
					</div>
					<div class="poll-users__info-container">
						<div class="poll-users__info-container__user-info">
							<span class="poll-users__info-container__user-name">{{ user.visible_username }}</span>
							<span class="poll-users__info-container__third_profile_row mt-1">{{user.third_profile_row}}</span>
						</div>
						<span class="poll-users__info-container__poll_answer">{{user.poll_answer}}</span>
					</div>


				</div>


			</div>
		<div
			class="d-flex my-9 justify-center home-page__pagination"
			v-if="!postPollUsersLoading && postPollUsers.length > 0"
		>
			<Pagination
				:page="filters.page"
				:pageCount="+this.pollUsersPageCount"
				v-on:pageChange="onPageChange"
			/>
		</div>
	</div>

</template>



<script>
import { mapActions, mapGetters } from 'vuex'
import Avatar from '@/components/Avatar.vue'
import Filter from '@/mixins/Filter'
import Pagination from '@/components/Pagination.vue'
import FilterChipButton from '@/components/FilterChipButtons.vue'
import FilterModal from '@/components/Modals/FilterModal.vue'
import NewsFeedEmpty from "@/components/Post/NewsFeedEmpty.vue";
export default {
	name: 'PollUsers',
	mixins: [Filter],
	components: {
    NewsFeedEmpty,
		FilterModal, FilterChipButton,
		Pagination,
		Avatar
	},
	data() {
		return {

		}
	},
	computed: {
		...mapGetters('post',['post','postPollUsers','pollUsersPageCount','postPollUsersLoading']),
		chipsFromFilterPoll() {
			if (!this.post || !this.post.poll || !this.post.poll.pollsAnswers) {
				return [];
			}

			return this.post.poll.pollsAnswers.map(answer => ({
				poll_answer_id: answer.poll_answer_id,
				poll_answer: answer.poll_answer
			}));
		}


	},
	methods: {
		...mapActions('post', ['getPollUsers','getPost']),
		...mapActions('app',['setPageTitle'])

	},
	mounted() {
		this.setPageTitle('Poll Results');
	},
	created() {
		this.getPollUsers(this.requestQuery);
		this.getPost(this.$route.query.thread_id)
	},
	beforeDestroy() {
		this.setPageTitle('');
	},


}
</script>

<style lang="scss">
 .poll-users {
	 &__title {
		 font-family: 'Montserrat', sans-serif;
		 font-weight: 700;
		 font-size: 18px;
		 line-height: 22.07px;
		 color: #4a4a4a;
	 }
	 &__container {
		 display: flex;
		 align-items: center;
		 padding: 12px;
		 background-color: #ffffff;
		 border-radius: 8px;
		 margin-top: 8px;
		 min-height: 88px;
	 }
	 &__info-container{
		 display: flex;
		 flex-direction: column;
		 justify-content: space-between;
		 min-height: 64px;
		 &__user-info{
			 display: flex;
			 flex-direction: column;
		 }
		 &__user-name{
			 font-family: 'Inter', sans-serif;
			 font-weight: 700;
			 font-size: 16px;
			 line-height: 19.36px;
			 color: var(--accent-color);
		 }
		 &__third_profile_row{
			 font-family: 'Inter', sans-serif;
			 font-weight: 400;
			 font-size: 13px;
			 line-height: 15.73px;
			 color: #4a4a4a;
		 }
		 &__poll_answer{
			 font-family: 'Inter', sans-serif;
			 font-weight: 700;
			 font-size: 14px;
			 line-height: 16.94px;
			 color: #4a4a4a;
		 }
	 }
 }

</style>